export default "__VITE_ASSET__BTCqv5BP__"